import { FormRow } from '@op/opds.opux';
import { Stepper } from '@op/opds.opux-stepper';
import React, { ReactElement } from 'react';

interface StepperFormRowProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  unit: string;
  onChange: React.Dispatch<React.SetStateAction<number>>;
}

const StepperFormRow = ({
  label,
  value,
  min,
  max,
  step,
  unit,
  onChange,
}: StepperFormRowProps): ReactElement => {
  return (
    <FormRow label={label}>
      <Stepper
        size="small"
        value={value}
        min={min}
        max={max}
        step={step}
        unit={unit}
        onChange={onChange}
        className="investoracademy-course6-stepper"
      />
    </FormRow>
  );
};

export default StepperFormRow;
